import './config/polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import store from './config/store'
import { ApolloProvider } from 'react-apollo'
import { BrowserRouter, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { CookiesProvider } from 'react-cookie'
import CookieAcceptance from 'components/CookieAcceptance'
import { Theme } from 'stylist'
import client from './config/apollo/client'
import 'normalize.css'
import './styles/global'
import './config/raven'
import './config/zendesk'

ReactDOM.render(
  <ApolloProvider client={client}>
    <CookiesProvider>
      <Provider store={store}>
        <Theme>
          <CookieAcceptance>
            <BrowserRouter>
              <Route component={App} />
            </BrowserRouter>
          </CookieAcceptance>
        </Theme>
      </Provider>
    </CookiesProvider>
  </ApolloProvider>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js